<div class="row no-gutters minus-gutters">
  <app-balance-card
    class="col-xl-3 col-md-6 col-xs-12 pt-1" *ngFor="let card of cards;let i = index"
    [class.pr-1]="i + 1 < cards.length"
    [card]="card" [showVerification]="verificationLevel === 0"></app-balance-card>
</div>
